import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

export default class DateRange extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChangeStart = date => {
    this.props.onChangeDateRange({
      startDate: date,
      endDate: moment(this.props.endDate)
    });
  };

  handleChangeEnd = date => {
    this.props.onChangeDateRange({
      startDate: moment(this.props.startDate),
      endDate: date
    });
  };

  render() {
    return (
      <div className="root">
        <p>Selecione uma data de início</p>

        <div className="date-picker">
          <DatePicker
            className="input"
            dateFormat="DD/MM/YYYY"
            locale="pt-BR"
            minDate={moment("2018-01-01")}
            maxDate={moment()}
            selected={moment(this.props.startDate)}
            selectsStart
            startDate={moment(this.props.startDate)}
            endDate={moment(this.props.endDate)}
            onChange={this.handleChangeStart}
          />
        </div>

        <p>e fim</p>

        <div className="date-picker">
          <DatePicker
            className="input"
            dateFormat="DD/MM/YYYY"
            locale="pt-BR"
            minDate={moment("2018-01-01")}
            maxDate={moment()}
            selected={moment(this.props.endDate)}
            selectsEnd
            startDate={moment(this.props.startDate)}
            endDate={moment(this.props.endDate)}
            onChange={this.handleChangeEnd}
          />
        </div>

        <p>para obter as estatísticas</p>

        <style jsx>{`
          .root {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            align-content: space-around;
          }

          .date-picker {
            padding: 0 10px;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// components/shared/DateRange.js